export enum MatchEventSubType {
  None = '',
  GoalOwnGoal = 'goal_own_goal',
  GoalFreekick = 'goal_freekick',
  PenaltyFoul = 'penalty_foul',
  PenaltyHand = 'penalty_hand',
  PenaltyShootout = 'penalty_shootout',
  GoalShot = 'goal_shot',
  GoalHeaded = 'goal_headed',
  GoalDistanceShot = 'goal_distance_shot',
  GoalScrounger = 'goal_scrounger',
  CardYellow = 'card_yellow',
  CardYellowRed = 'card_yellow_red',
  CardRed = 'card_red',
  TimeoutStart = 'timeout_start',
  TimeoutStop = 'timeout_stop',
  WhistleRegularStartFirstHalftime = 'whistle_regular_start_first_halftime',
  WhistleRegularStopFirstHalftime = 'whistle_regular_stop_first_halftime',
  WhistleRegularStartSecondHalftime = 'whistle_regular_start_second_halftime',
  WhistleRegularStopSecondHalftime = 'whistle_regular_stop_second_halftime',
  WhistleOvertimeStartFirstHalftime = 'whistle_overtime_start_first_halftime',
  WhistleOvertimeStopFirstHalftime = 'whistle_overtime_stop_first_halftime',
  WhistleOvertimeStartSecondHalftime = 'whistle_overtime_start_second_halftime',
  WhistleOvertimeStopSecondHalftime = 'whistle_overtime_stop_second_halftime',
  WhistlePenaltyShootoutStart = 'whistle_penalty_shootout_start',
  WhistlePenaltyShootoutStop = 'whistle_penalty_shootout_stop',
  TimePenaltyStart = 'time_penalty_start',
  TimePenaltyStop = 'time_penalty_stop',
}
